import { useContext } from 'react';
import { AuthContext } from '@/contexts/AuthContext';

/**
 * Hook to access authentication context
 * Must be used within AuthProvider
 *
 * @throws Error if used outside AuthProvider
 * @returns Authentication context with user, login, logout functions
 */
export function useAuth() {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}
